import { tsParticles } from "@tsparticles/engine";
import { loadConfettiPreset } from "@tsparticles/preset-confetti";

document.addEventListener("alpine:init", () => {
    window.Alpine.data("fundedConfetti", () => ({
        init() {
            const loadEngine = async (engine) => {
                await loadConfettiPreset(engine);

                const emitterOptions = {
                    startCount: 25,
                    life: {
                        count: 1,
                        duration: 4,
                    },
                    rate: {
                        quantity: 5,
                        delay: 0.1,
                    },
                    direction: "top",
                };

                setTimeout(() => {
                    tsParticles.load({
                        id: "tsparticles",
                        options: {
                            particles: {
                                number: { value: 45 },
                                color: { value: ["#FF34F5", "#FFCD58", "#2BFFFF"] },
                                shape: {
                                    type: "square",
                                },
                                size: {
                                    value: 10,
                                },
                                move: {
                                    speed: 350,
                                },
                            },
                            emitters: [
                                {
                                    position: {
                                        x: 90,
                                        y: 30,
                                    },
                                    particles: {
                                        move: {
                                            speed: 50,
                                        },
                                    },
                                    startCount: 25,
                                    life: {
                                        count: 1,
                                        duration: 2,
                                    },
                                    rate: {
                                        quantity: 10,
                                        delay: 0.1,
                                    },
                                    direction: "up",
                                },
                                {
                                    position: {
                                        x: 50,
                                        y: 100,
                                    },
                                    ...emitterOptions,
                                },
                                {
                                    position: {
                                        x: 15,
                                        y: 100,
                                    },
                                    ...emitterOptions,
                                },
                                {
                                    position: {
                                        x: 85,
                                        y: 100,
                                    },
                                    ...emitterOptions,
                                },
                            ],
                            preset: "confetti",
                        },
                    });
                }, 1200);
            };
            loadEngine(tsParticles);
        },
    }));
});
